import React from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from 'mage-deps/@klarna/bubble-ui'

import { EnvironmentId } from 'mage-deps/@klarna/mp-ui'
import { selectors as configSelectors } from 'mage-config'
import { constants as commonConstants } from 'mage-common'
import { translator } from 'mage-i18n'

import CMSEnvironmentSelector from './CMSEnvironmentSelector'

const { ENVS } = commonConstants

const tooltipStyle = {
  display: 'none',
  justifyContent: 'center',
  position: 'absolute',
  top: '25px',
  left: 'calc(50% - 150px)',
  minWidth: '300px',
  zIndex: 106
}

function toggleTooltip (evt) {
  evt.stopPropagation()
  const tooltip = document.getElementById('tooltip')
  if (tooltip) {
    tooltip.style.display = tooltip.style.display === 'none' ? 'flex' : 'none'
  }
}

export const EnvironmentIdentifier = () => {
  const environment = useSelector(configSelectors.environment)
  const region = useSelector(configSelectors.region)
  const t = useSelector(translator)

  if (environment === ENVS.PRODUCTION || !Object.values(ENVS).includes(environment)) return null
  const devTooltip = (
    <div id='tooltip' style={tooltipStyle}>
      <Tooltip inverse isNotText arrow='top'>
        <CMSEnvironmentSelector />
      </Tooltip>
    </div>
  )
  return (
    <>
      <EnvironmentId env={environment} text={`${t(`config.environments.${environment}`)} (${region})`} onClick={toggleTooltip} />
      {[ENVS.STAGING, ENVS.DEVELOPMENT].includes(environment) && devTooltip}
    </>
  )
}

export default EnvironmentIdentifier
